import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import Select from "react-select";
import { useCreateFacturationMode } from '../../../hooks/TICKET/useCreateFacturationMode';
import { useColors } from '../../../hooks/COLORS/useColors';
import { customSelectStyles } from '../../../utils/reactSelectStyles';

const NewFacturationMode = ({ showNewFacturationMode, setShowNewFacturationMode }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ label: '', couleur: null, defaut: false });

    const { mutateAsync: createMode } = useCreateFacturationMode();
    const { data: colorsData, isLoading: isLoadingColors } = useColors();

    const colorOptions = colorsData?.data?.map(color => ({
        value: color.id.toString(), label: color.name, hex: color.hex,
    })) ?? [];

    const formatColorOption = ({ label, hex }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ width: '14px', height: '14px', borderRadius: '50%', backgroundColor: hex || '#e9ecef', border: '1px solid #ced4da', flexShrink: 0 }} />
            <span>{label}</span>
        </div>
    );

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        if (!formData.label) { alert("Le label est obligatoire"); return; }
        setIsSubmitting(true);
        try {
            await createMode({ label: formData.label, couleur: formData.couleur ? parseInt(formData.couleur.value) : undefined, defaut: formData.defaut });
            setFormData({ label: '', couleur: null, defaut: false });
            setShowNewFacturationMode(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={showNewFacturationMode} onHide={() => setShowNewFacturationMode(false)} size='md'>
            <Form onSubmit={handleSubmitForm}>
                <Modal.Header closeButton>
                    <Modal.Title><h5 className='text-muted modal-title'>Ajouter une méthode de facturation</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="idLabel">
                        <Form.Label className='text-muted'>Label (obligatoire)</Form.Label>
                        <Form.Control type="text" placeholder="Label" value={formData.label} onChange={(e) => setFormData({ ...formData, label: e.target.value })} required />
                    </Form.Group>
                    <Form.Group className='mb-3' controlId="idCouleur">
                        <Form.Label className='text-muted'>Choisissez une couleur (optionnel)</Form.Label>
                        <Select options={colorOptions} value={formData.couleur} formatOptionLabel={formatColorOption} onChange={(option) => setFormData({ ...formData, couleur: option })} isLoading={isLoadingColors} menuPortalTarget={document.body} styles={{ ...customSelectStyles, menuPortal: base => ({ ...base, zIndex: 9999 }) }} placeholder="Sélectionnez une couleur" isClearable />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="idDefaut">
                        <Form.Check type="checkbox" label="Méthode par défaut" checked={formData.defaut} onChange={(e) => setFormData({ ...formData, defaut: e.target.checked })} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={isSubmitting} onClick={() => setShowNewFacturationMode(false)}>Annuler</Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Chargement...' : 'Créer'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default NewFacturationMode;